// extracted by mini-css-extract-plugin
module.exports = {"modal":"_1AYmWIGgwz0X4u6OD96Lss"};